import { takeUntil } from 'rxjs/operators';
import { CompanyService } from './../../../../../providers/services/company.service';
import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { Product, Company } from '@pdp/common';
import { Subject } from 'rxjs';
import { NgIf, NgFor, SlicePipe } from '@angular/common';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ProductBoxTwoComponent } from '../../two/product-box-two/product-box-two.component';

@Component({
    selector: 'pdp-product-slider-two',
    templateUrl: './product-slider-two.component.html',
    styleUrls: ['./product-slider-two.component.scss'],
    imports: [NgIf, SlickCarouselModule, NgFor, ProductBoxTwoComponent, SlicePipe]
})
export class ProductSliderTwoComponent implements OnInit {
  protected unsubscribe: Subject<void> = new Subject();

  public company: Company;
  @Input()
  public products: Product;

  @Input()
  public promotionMessage: string;

  @Input()
  public displayPromotionMessage: boolean;

  constructor(public companyService: CompanyService) {}

  ngOnInit() {
    this.companyService.getValue
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((company: Company) => {
        this.company = company;
      });
  }

  // Slick slider config
  public productSlideConfig: any = {
    infinite: true,
    speed: 800,
    slidesToShow: 5,
    slidesToScroll: 5,
    autoplay: true,
    autoplaySpeed: 3500,
    nextArrow:
      "<div class='slick-next-custom'><svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='20' height='20' viewBox='0 0 20 20'><path fill='#000000' d='M5 20c-0.128 0-0.256-0.049-0.354-0.146-0.195-0.195-0.195-0.512 0-0.707l8.646-8.646-8.646-8.646c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l9 9c0.195 0.195 0.195 0.512 0 0.707l-9 9c-0.098 0.098-0.226 0.146-0.354 0.146z'></path></svg></div>",
    prevArrow:
      "<div class='slick-prev-custom'><svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='20' height='20' viewBox='0 0 20 20'><path fill='#000000' d='M14 20c0.128 0 0.256-0.049 0.354-0.146 0.195-0.195 0.195-0.512 0-0.707l-8.646-8.646 8.646-8.646c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-9 9c-0.195 0.195-0.195 0.512 0 0.707l9 9c0.098 0.098 0.226 0.146 0.354 0.146z'></path></svg></div>",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
        },
      },
    ],
  };

  ngOnDestroy() {
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }

  public ngOnChanges(changes: SimpleChanges) {}
}
